/*import { NgModule } from '@angular/core';
import { IonicPageModule } from 'ionic-angular';
import { PotatoseedorderPage } from './potatoseedorder';
import {PipesModule} from "../../pipes/pipes.module";

@NgModule({
  declarations: [
    FormsPotatoseedPage,
  ],
  imports: [
    IonicPageModule.forChild(PotatoseedorderPage),
    PipesModule
  ],
  exports: [
    FormsPotatoseedPage
  ]
})
export class PotatoseedorderPageModule {}


---
*/

import {PipesModule} from "../../../pipes/pipe.module";

import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

import { IonicModule } from '@ionic/angular';

import { PotatoseedorderPageRoutingModule } from './potatoseedorder-routing.module';

import { PotatoseedorderPage } from './potatoseedorder';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    PotatoseedorderPageRoutingModule,
    PipesModule
  ],
  declarations: [PotatoseedorderPage]
})
export class PotatoseedorderPageModule {}
